import React, { useEffect, useState } from 'react';
import {
  IconDownload,
  Button,
  Tabs,
  Table,
  IconClipboard,
  useToast
} from '@veneer/core';

import detailsStatementConfig from './DetailsStatement.config';
import ConnectAPI from '../../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { numberFormatCommaTwoFraction } from './../../../../common/js/utils/numberFormat';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import XLSX from 'xlsx';

const DetailsStatement = (props) => {
  const { id, idChannel } = props.match.params;

  let endUser = JSON.parse(localStorage.getItem('endUser'));
  let endUserName = '';
  if (endUser !== null && endUser.idEndUser === id) {
    endUserName = endUser.endUserName;
  }

  const RenderStatementTable = () => {
    const { t, i18n } = useTranslation();
    const [activeTabIndex, setactiveTabIndex] = useState(3);
    const [seriesSelected, setseriesSelected] = useState(3);
    const connectApi = new ConnectAPI();
    const { id, idChannel } = props.match.params;
    const [config, setConfig] = useState(detailsStatementConfig.columns);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [order, setOrder] = useState(config.map((c) => c.id));
    const [orderBy, setOrderBy] = useState('dateFormatted');
    const [orderType, setOrderType] = useState('descending');
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 50;

    const [nextId, setNextId] = useState(0);
    const { addToast } = useToast();
    const [logs, setLogs] = useState([]);
    const [reportDates, setReportDates] = useState([]);
    const [costPerPrintEvolution, setCostPerPrintEvolution] = useState([]);

    const exportData = () => {
      setLoadingExport(true);
      setTimeout(() => {
        let excelData = tableData;
        let headerEndUsers = [
          'date',
          'description',
          'bonusMonth',
          'credit',
          'debit',
          'balance',
        ];
        const dataXlsx = excelData.map((item) => {
          return {
            date: item.date,
            description: item.description,
            bonusMonth: item.bonusMonth,
            credit: item.credit,
            balance: item.balance,
            debit: item.debit,
          };
        });
        const ws = XLSX.utils.json_to_sheet(dataXlsx, {
          header: headerEndUsers,
        });
        const wb = XLSX.utils.book_new();

        const date = moment(new Date()).format('YYYYMMDDHHmm');

        const filename = 'CompensationStatement -' + date + '.xlsx';
        const ws_name = 'Balance';

        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, filename);

        setLoadingExport(false);
      }, 750);
    };

    const handleRedeemCompensation = (index) => {
      setIsLoading(true);
      connectApi
        .get(
          'api/Channels/EnableToOrder',
          {
            params: {
              customerId: JSON.parse(localStorage.getItem("currentUser")).idCustomer,
              endUserId: JSON.parse(localStorage.getItem("currentUser")).idEndUser,
              series: seriesSelected,
            },
          },
          enableResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          if (error?.response?.data.includes('An order is in progress')) {
            addToast({ id: nextId, type: 'warning', text: t('orderInProgressAlert'), timeout: 20 });
            setNextId(prev => prev + 1);
          } else {            
            Swal.fire(
              'Error ' + error?.response?.status,
              error?.response?.data,
              'error'
            );
          }
        });
    };
    const enableResponseLoad = (status, data) => {
      setIsLoading(false);
      const { history } = props;

      history.push({
        pathname:
          '/cpp/report/statement/redeem/' +
          id +
          '/' +
          idChannel +
          '/' +
          seriesSelected,
        state: { detail: seriesSelected },
      });
    };
    const handleSelectReport = (index) => (event) => {
      event.preventDefault();

      const { history } = props;

      history.push({
        pathname: '/cpp/report/statement/order/' + index.idOrder,
        data: index,
      });
    };

    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);

        connectApi
          .get('api/Channels/CompensationStatement/' + id, '', dataResponseLoad)
          .catch((error) => {
            setIsLoading(false);
            console.log(error);
            Swal.fire(
              'Error ' + error?.response?.status,
              error?.response?.data,
              'error'
            );
          });
      };

      const dataResponseLoad = (status, data) => {
        data.map((item) => {
          item.debitFormatted =
            item.debit == null ? '-' : numberFormatCommaTwoFraction(item.debit);
          item.balanceFormatted =
            item.balance == null
              ? '-'
              : numberFormatCommaTwoFraction(item.balance);
          item.creditFormatted =
            item.credit == null
              ? '-'
              : numberFormatCommaTwoFraction(item.credit);
          if (item.showOrder) {
            item.debitFormatted = (
              <a href={item.debitFormatted} onClick={handleSelectReport(item)}>
                {item.debitFormatted}
              </a>
            );
          } else {
            item.debitFormatted = item.debit;
          }
          item.dateFormatted = moment(item.date).format('DD-MM-YYYY');
        });

        if (data.some((x) => x.series == 6)) {
          setseriesSelected(6);
          setactiveTabIndex(6);
        } else if (data.some((x) => x.series == 5)) {
          setseriesSelected(5);
          setactiveTabIndex(5);
        } else if (data.some((x) => x.series == 4)) {
          setseriesSelected(4);
          setactiveTabIndex(4);
        }
        
        setTableData(data === undefined ? [] : data);
        setIsLoading(false);
      };
      const fetchlog=async()=>{
        connectApi
          .get("api/Channels/endusers/" + id + "/statementDescription", '', datalog)
          .catch((error) => {
            setIsLoading(false);
            console.log(error);
            Swal.fire(
              'Error ' + error?.response?.status,
              error?.response?.data,
              'error'
            );
          });
      }
      const datalog=(status,data)=>{
        setLogs(data.logs);
        setReportDates(data.reportDates);
      }
     
      /*if ([9,10].findIndex((role) => role == JSON.parse(localStorage.getItem("currentUser")).idRole) > -1){
        if (idChannel!=JSON.parse(localStorage.getItem("currentUser")).idCustomer){
          const { history } = props;
            history.push({
              pathname: '/cpp/report/',
            });
        }
      }
      if ([11,12].findIndex((role) => role == JSON.parse(localStorage.getItem("currentUser")).idRole) > -1){
       
          if (id.toUpperCase()!=JSON.parse(localStorage.getItem("currentUser")).idEndUser.toUpperCase()){
            const { history } = props;
              history.push({
                pathname: '/cpp/report/' + JSON.parse(localStorage.getItem("currentUser")).idEndUser,
              });
          }
        
        
      }*/
      
      fetchlog();
      fetchData();
      
    }, []);
    if (reportDates.length>0){
      var item=reportDates[0];
      var dateSelected={
        month: parseInt(moment(item.date).format("M")),
        year: parseInt(moment(item.date).format("YYYY")),
      }
      function getCompStatus() {
        
        const dateSelectedLogs = logs.filter((log) => {
          return (
            log.month == dateSelected.month &&
            log.year == dateSelected.year &&
            (log.actionDescription == "Compensation Accepted" ||
              log.actionDescription == "Compensation Issue Raised")
          );
        });
    
        if (dateSelectedLogs.length == 0) return "No Logs";
  
        return dateSelectedLogs[0].actionDescription;
      }
    
      const compStatus = getCompStatus();
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if ([11,12].findIndex((role) => role == currentUser.idRole) > -1){
          if (compStatus != "Compensation Accepted" ){
            ////reload to back
            const { history } = props;
            history.push({
              pathname: '/cpp/report/' + currentUser.idEndUser,
            });
            // 
        
        }
        
      }  
      if ([9,10].findIndex((role) => role == currentUser.idRole) > -1){
        if (compStatus != "Compensation Accepted" ){
            ////reload to back
            const { history } = props;
            history.push({
              pathname: '/cpp/report/' + id,
            });
            // 
        }
      } 
    }
    
    
    //const filteredData = filterSort(tableData, {}, orderBy, orderType);
    const filteredData = filterSort(
      tableData.filter((x) => x.series == seriesSelected),
      {},
      orderBy,
      orderType
    );

    const pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );

    const handleSelect = (event, index) =>
      setTableData(selectRow(tableData, event.target.checked, index));

    const handleSelectPage = (event) => {
      const newTableData = Array.from(tableData, (v) => {
        const newValue = v;
        const index = pagedData.findIndex((p) => p.sid === newValue.sid);
        if (index > -1) {
          newValue.rowConfig.selected = event.target.checked;
        }
        return newValue;
      });

      setTableData(newTableData);
    };

    const handleSort = (_, { id, type }) => {
      setOrderBy(id);
      setOrderType(type);
    };

    const handlePageChange = (page) => setCurrentPage(page);

    const handleOnColumnReorder = (newOrder) => {
      setOrder(newOrder);
    };

    function descendingComparator(a, b, orderBy) {
      let aSort =
        typeof a[orderBy] === 'object'
          ? typeof a[orderBy] === typeof (<a />)
            ? a[orderBy].props.href.toString().toUpperCase()
            : a[orderBy].props.label.toString().toUpperCase()
          : a[orderBy].toString().toUpperCase();
      //const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
      let bSort =
        typeof b[orderBy] === 'object'
          ? typeof b[orderBy] === typeof (<a />)
            ? b[orderBy].props.href.toString().toUpperCase()
            : b[orderBy].props.label.toString().toUpperCase()
          : b[orderBy].toString().toUpperCase();
      //const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

      if (orderBy === 'dateFormatted') {
        aSort = a['date'];
        bSort = b['date'];
      } else {
        if (orderBy.includes('Formatted')) {
          const orderByFormatted = orderBy.replace('Formatted', '');
          aSort = a[orderByFormatted];
          bSort = b[orderByFormatted];
        }
      }
      if (bSort < aSort) {
        return -1;
      }
      if (bSort > aSort) {
        return 1;
      }
      return 0;
    }

    function filterSort(array, filters, orderBy, orderType) {
      let arrayFiltered = array;
      // filter
      Object.keys(filters).forEach((value) => {
        const filterValue = filters[value];
        const filter =
          typeof filterValue === 'object' ? filterValue[0] : filterValue;
        if (filter) {
          arrayFiltered = arrayFiltered.filter((a) => {
            const aUpper = a[value] && a[value].toString().toUpperCase();
            const filterUpper = filter && filter.toString().toUpperCase();

            return aUpper.indexOf(filterUpper) > -1;
          });
        }
      });

      // sort
      return arrayFiltered.sort((a, b) => {
        const value =
          orderType === 'descending'
            ? descendingComparator(a, b, orderBy)
            : -descendingComparator(a, b, orderBy);

        return value;
      });
    }

    function selectRow(dataArray, checked, id) {
      const updatedDataArray = [...dataArray];
      const index = updatedDataArray.findIndex((row) => row.sid === id);
      updatedDataArray[index].rowConfig.selected = checked;
      return updatedDataArray;
    }

    const RenderTabs = () => {
      const series6 = tableData.some((x) => x.series == 6);
      const series5 = tableData.some((x) => x.series == 5);
      const series4 = tableData.some((x) => x.series == 4);
      const series3 = tableData.some((x) => x.series == 3);
      const series3Tab = {
        id: 3,
        label: <Trans i18nKey='series3' />,
        content: TableRender,
      };
      const series4Tab = {
        id: 4,
        label: <Trans i18nKey='series4' />,
        content: TableRender,
      };
      const series5Tab = {
        id: 5,
        label: "Series 5",
        content: TableRender,
      };
      const series6Tab = {
        id: 6,
        label: "Series 6",
        content: TableRender,
      };
      let list = [];
      if (series3) list.push(series3Tab);
      if (series4) list.push(series4Tab);
      if (series5) list.push(series5Tab);
      if (series6) list.push(series6Tab);
      if (list.length == 0) list.push(series3Tab);
      
      const tab = (
        <Tabs
          controlId="default"
          onChangeTab={selectTab()}
          selectedTabId={activeTabIndex}
          tabs={list}
        >
          {list}
        </Tabs>
      );

      return tab;
    };

    const selectTab = (index) => (event) => {
      setactiveTabIndex(event);
      setseriesSelected(event);
    };

    const TableRender = (
      <div
        style={{
          backgroundColor: '#f2f2f2',
          padding: '0.5%',
          maxWidth: '780px',
        }}
      >
        <div>
          <Table
            columnReorder
            columns={config}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSelect={handleSelect}
            onSelectAll={handleSelectPage}
            onSort={handleSort}
            preferences={{
              defaultOrder: config.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
            loading={isLoading} 
          ></Table>

          <div style={{ textAlign: 'left', marginBottom: '12px' }}>
            <Button
              leadingIcon={<IconDownload />}
              onClick={() => {
                exportData();
              }}
              disabled={tableData === 0}
              loading={loadingExport}
              title={t('download data')}
            >
              <Trans i18nKey='download' />
            </Button>
            <Button
              style={{ marginLeft: '8px' }}
              leadingIcon={<IconClipboard />}
              onClick={() => handleRedeemCompensation()}
              loading={isLoading}
            >
              <Trans i18nKey='redeem' />
            </Button>
          </div>
        </div>
      </div>
    );

    return (
      <div>
        <br />
        {isLoading?(""):(<RenderTabs />)}
      </div>
    );
  };

  return (
    <div>
      <div style={{
        paddingTop: '10px',
        position: 'fixed',
        zIndex: '4',
        width: '100%',
        backgroundColor: 'white',
        borderBottomStyle: 'solid',
        borderBottomColor: '#ebebeb',
        borderBottomWidth: 'thin'
      }}>
        <h4 style={{ marginBottom: '10px' }}> <Trans i18nKey='compensationstatement' /> - {endUserName}</h4>
      </div>
      <div style={{ paddingTop: '3%' }}>
        {RenderStatementTable()}
      </div>
    </div>
  );
};
export default DetailsStatement;
